import { completeOrders } from "@/api/drivers";
import { BaseStaticSelect } from "@/components/input/CustomInputs";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Dispatch, FC, SetStateAction, useState } from "react";

interface Props {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  selectedIds: number[];
}

const CompleteOrderDialog: FC<Props> = ({ open, setOpen, selectedIds }) => {
  const [formProp, setFormProp] = useState<{can_complete_order: "yes" | "no"}>({ can_complete_order: "no" });

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirm your action</DialogTitle>
          <DialogDescription>
            All {selectedIds.length} drivers are about to be given a perimission
            whenver they can complete an order or not.
          </DialogDescription>
        </DialogHeader>
        <BaseStaticSelect
          id="can_complete_order"
          label=""
          value={formProp.can_complete_order}
          setValue={setFormProp}
          data={[
            { label: "They can complete an order", value: "yes" },
            { label: "They cannot complete an order", value: "no" },
          ]}
        />
        <DialogFooter className="flex justify-end gap-x-2">
          <Button variant="outline" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button
            onClick={async () => await completeOrders({selectedIds, can_complete_order: formProp.can_complete_order === "yes" ? true : false}, setOpen)}
          >
            Proceed
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CompleteOrderDialog;
